import { TEMPLATE_TYPE } from '../models/template';
import { SubjectType } from '../models/subject-type';
import { ReplaySubject } from 'rxjs';
import { Subject } from '../models/subject';
import { Process } from '../models/process';

export class Grid {
  items = [];
  size = 70; // specify width and height of each 'cell' in the grid

  onValueChanged: ReplaySubject<any> = new ReplaySubject<any>(1);

  get values() {
    const values = [];
    this.items.forEach((item) => {
      values.push({ id: item.id, value: item.metadata.value });
    });
    return values;
  }

  set values(val) {
    if (val) {
      val.forEach((item) => {        
        const itemsToUpdate = this.items.filter((gridItem) => (gridItem.id === item.id) && (!(gridItem.type && (gridItem.type.toString().toLowerCase() === 'label'))));        
        itemsToUpdate.forEach((itemToUpdate) => {
          if (itemToUpdate.type.toString().toLowerCase() === 'fieldvalue') {            
            itemToUpdate.metadata.value = item.displayValue;
            itemToUpdate.metadata.type = item.type;
          }
          else {
            itemToUpdate.metadata.value = item.value;
            // if using a lookup check current value is included in list of possible values
            if (item.value) {
              const pv = itemToUpdate.metadata.possibleValues;
              if (pv) {
                // if possible values are specified then probably a lookup
                // convert the value to a number, just in case
                let val = Number(item.value);
                if (isNaN(val)){
                  val = item.value;
                }
                if (!pv.find((i) => i.id === val)) {
                  const foundItem = pv.find((i) => i.value.toString().toLowerCase() === item.value.toString().toLowerCase());
                  if (foundItem){
                    itemToUpdate.metadata.value = foundItem.id;
                  } else {
                    // get index for insert - either after 'None' or at the beginning of the list
                    // MRD - logically if the value doesn't exist then setting it is going to cause problems...
                    // const idx = ((pv.length > 0) && (pv[0].value === 'None')) ? 1 : 0;
                    // pv.splice(idx, 0, { id: item.value, value: item.displayValue });

                    // ...doesn't exist, so set to undefined
                    itemToUpdate.metadata.value = undefined;
                  }
                }
                else{
                  itemToUpdate.metadata.value = val;
                }
              }
            }
          }
        });
      });

      // set the initial state for valid
      this.items.forEach((item) => {
        item.valid = item.valid || (!(item.metadata.required && (!(item.metadata.value || (item.metadata.value === false) || (item.metadata.value === 0)))));
      });
    }
  }

  get valid(): boolean {
    return this.items.findIndex((item) => !item.valid) === -1;
  }

  constructor() { }

  getCategoryInfo(categoryName, categoryId, template, type) {
    const categoryItem = template.layoutItems.find((i) => (i.name.toLowerCase() === categoryName));
    const categoryField = type.getDataField(categoryName);
    return {
      id: categoryId,
      name: categoryName,
      required: (categoryField && categoryField.required),
      item: categoryItem,
      assigned: categoryId,
    };
  }

  updateItem(dataItem) {
    const w = this.items.find((x) => x.id === dataItem.id);
    if (w) {
      let bValidChanged = false;
      w.metadata.value = dataItem.value;
      if (w.valid !== dataItem.valid) {
        bValidChanged = true;
        w.valid = dataItem.valid;
      }
      if (dataItem.valid || bValidChanged) {
        // raise onValueChanged notification
        this.onValueChanged.next(dataItem);
      }
    }
  }

  resetFieldValues() {
    this.items.filter((layoutItem) => (layoutItem.type.toString().toLowerCase() === 'fieldvalue')).forEach((w) => w.metadata.value = '');
  }

  addItems(subject: Subject | Process, widgetService, template, type, categoryInfo?, autoGenerateReference?, readOnly?) {
    const referenceName = 'reference';
    const cardTemplate = (template.type.toLowerCase() === TEMPLATE_TYPE.CARD.toLowerCase()) 
                          || (template.type.toLowerCase() === TEMPLATE_TYPE.REFERRALCARD.toLowerCase());
    // add layout items from template in sorted order
    widgetService.getSortedLayoutItems(template.layoutItems).forEach((item) => {
      const dataField = type.getDataField(item.name);
      if (dataField) {
        if (!cardTemplate) {
          const name = item.name.toLowerCase();
          if (name === referenceName) {
            dataField.readonly = autoGenerateReference;
            dataField.required = !autoGenerateReference;
          }
          else {
            if (categoryInfo && (name === categoryInfo.name)) {
              dataField.readonly = false;
            }
            else {
              dataField.readonly = (categoryInfo && categoryInfo.item && categoryInfo.required && (!categoryInfo.assigned));
            }
            if (dataField.dataType.toLowerCase() === 'calculated') {
              dataField.readonly = true;
            }
          }
        }

        const subjectTypeId = (type instanceof SubjectType) ? type.id : undefined;
        const widget = widgetService.fieldAsWidget(subject, dataField, item.layoutInformation, subjectTypeId, (categoryInfo) ? categoryInfo.id : undefined);
        widget.type = item.type || 'LABEL';
        const widgetType = widgetService.getWidgetType(widget.type);
        widget.widget = widgetService.getWidget(widgetType);
        if (cardTemplate) {
          widget.metadata.value = widget.metadata.label;
        }
        widget.metadata.readonly = readOnly || widget.metadata.readonly || cardTemplate;
        this.items.push(widget);
      }
      else {
        let widget;
        switch (item.name.toLowerCase()) {
          case 'line': widget = widgetService.getLineWidget(99); break;
          case 'text': widget = widgetService.getHtmlWidget(98); break;
          default: break;
        }
        if (widget) {
          widget.config = item.layoutInformation;
          widget.metadata = item.metadata;
          const widgetType = widgetService.getWidgetType(widget.type);
          widget.widget = widgetService.getWidget(widgetType);
          this.items.push(widget);
        }
      }
    });
    if (cardTemplate) {
      this.resetFieldValues();
    }
  }
}
